import { useMemo } from "react";
import { ErrorFrequency, WordFrequency } from '..'

const useTabs = () => {
    const tabs = useMemo(
        () => [
            { label: "שכיחות מילים", component: WordFrequency },
            { label: "שכיחות טעויות", component: ErrorFrequency }
        ], []
    )

    return tabs
}

export default useTabs